import { render, staticRenderFns } from "./MangaKu.vue?vue&type=template&id=10096606&scoped=true&"
import script from "./MangaKu.vue?vue&type=script&lang=js&"
export * from "./MangaKu.vue?vue&type=script&lang=js&"
import style0 from "./MangaKu.vue?vue&type=style&index=0&id=10096606&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10096606",
  null
  
)

export default component.exports